// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"369":"7006e9bc","787":"d484c18d"}[chunkId] + ".chunk.js";
};